function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImagePrintAlign = function SvgImagePrintAlign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-7.56 -7.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1",
    d: "M9.405 9.405h20.308v20.308H9.405z",
    style: {
      fill: "none",
      strokeWidth: 1.69231,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "1.69231,5.07692",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1-7",
    d: "M17.405 17.405h20.308v20.308H17.405z",
    style: {
      fill: "none",
      strokeWidth: 1.69231,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  })));
};
export { SvgImagePrintAlign as ReactComponent };
export default __webpack_public_path__ + "assets/ImagePrintAlign.7559f3ce5002c4ecc3f57c00d1b13f95.svg";